import { Box, Grid, Typography } from "@mui/material";

import { Template } from "features/Influencer/ContactList/schema";

interface Props {
  template: Template;
}

const TemplateChip = ({ template }: Props) => {
  return (
    <Box key={template.id}>
      <Grid container justifyContent={"space-between"}>
        <Grid item xs>
          <Box sx={{}} key={template.id}>
            <Typography
              noWrap
              sx={{
                textOverflow: "ellipsis",
              }}
            >
              {template.name}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default TemplateChip;
